module.exports = __webpack_public_path__ + "img/bg_line_phone_contato.6f3adbe5.jpg";